module.exports = __webpack_public_path__ + "static/media/thin-old-man.ba4d5b63.png";